// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/several-days-gradient.svg';

export const SeveralDaysGradient = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
